import React from 'react'

const SupplierLedger = () => {
  return (
    <>
      <section className="section dashboard">

        {/* Filter Card */}
        <div className="row mb-3">
          <div className="col-lg-12">
            <div className="card border-0 shadow-sm" style={{ borderRadius: "16px" }}>
              <div className="card-body p-3">
                <div className="row g-2 align-items-end">

                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>From Date</label>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                        <i className="bi bi-calendar-event" style={{ color: "#1a3a8f", fontSize: "12px" }}></i>
                      </span>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        id="txtFromDate"
                        style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "#f8f9fe", fontSize: "13px" }}
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>To Date</label>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                        <i className="bi bi-calendar-check" style={{ color: "#1a3a8f", fontSize: "12px" }}></i>
                      </span>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        id="txtToDate"
                        style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "#f8f9fe", fontSize: "13px" }}
                      />
                    </div>
                  </div>

                  <div className="col-md-3">
                    <label className="form-label mb-1" style={{ fontSize: "11px", fontWeight: "700", color: "#8a9ab5", textTransform: "uppercase", letterSpacing: "0.6px" }}>Supplier</label>
                    <div className="input-group input-group-sm">
                      <span className="input-group-text" style={{ background: "#eef0ff", border: "1.5px solid #dde3ef", borderRight: "none", borderRadius: "8px 0 0 8px" }}>
                        <i className="bi bi-truck" style={{ color: "#1a3a8f", fontSize: "12px" }}></i>
                      </span>
                      <select
                        className="form-select form-select-sm"
                        id="ddlSupplier"
                        style={{ border: "1.5px solid #dde3ef", borderLeft: "none", borderRadius: "0 8px 8px 0", background: "#f8f9fe", fontSize: "13px" }}
                      >
                        <option>Select Supplier</option>
                        <option value="krishna">Krishna</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-md-3 d-flex gap-2">
                    <button
                      type="submit"
                      className="btn btn-sm text-white fw-semibold flex-grow-1 d-flex align-items-center justify-content-center gap-1"
                      style={{
                        background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
                        borderRadius: "8px", border: "none",
                        boxShadow: "0 3px 10px rgba(15,37,87,0.25)",
                        fontSize: "13px", height: "34px"
                      }}
                    >
                      <i className="fa-solid fa-magnifying-glass"></i> Search
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm fw-semibold d-flex align-items-center justify-content-center gap-1 px-3"
                      style={{
                        background: "#f0f4f8", border: "1.5px solid #dde3ef",
                        borderRadius: "8px", color: "#4a5568",
                        fontSize: "13px", height: "34px", whiteSpace: "nowrap"
                      }}
                    >
                      <i className="fa-solid fa-cloud-arrow-down"></i> Export
                    </button>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table Card */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card border-0 shadow-sm" style={{ borderRadius: "16px", overflow: "hidden" }}>
              <div className="card-body pb-0 p-3">

                {/* Table Header */}
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <div className="d-flex align-items-center gap-2">
                    <div style={{
                      width: "32px", height: "32px", borderRadius: "8px",
                      background: "linear-gradient(135deg, #0f2557 0%, #1a3a8f 100%)",
                      display: "flex", alignItems: "center", justifyContent: "center"
                    }}>
                      <i className="bi bi-journal-text text-white" style={{ fontSize: "14px" }}></i>
                    </div>
                    <div>
                      <span className="fw-bold" style={{ color: "#2d3748", fontSize: "15px" }}>Supplier Ledger</span>
                      <span className="ms-2 badge rounded-pill" style={{ background: "#eef0ff", color: "#1a3a8f", fontSize: "11px", fontWeight: "600" }}>
                        123 Records
                      </span>
                    </div>
                  </div>
                </div>

                {/* Table */}
                <div className="table-responsive" style={{ height: "calc(100vh - 380px)" }}>
                  <table className="table table-hover mb-0" style={{ fontSize: "13px" }}>
                    <thead>
                      <tr style={{ background: "#f8f9fe" }}>
                        {["Supplier Name", "Supplier ID", "Invoice No", "Debit", "Credit", "Balance", "Booking Type", "Date", "Remark"].map((h, i) => (
                          <th key={i} style={{
                            fontSize: "11px", fontWeight: "700", color: "#8a9ab5",
                            textTransform: "uppercase", letterSpacing: "0.6px",
                            borderBottom: "2px solid #e8edf5", padding: "10px 12px",
                            whiteSpace: "nowrap", background: "#f8f9fe"
                          }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {[1, 2].map((_, index) => (
                        <tr key={index}
                          style={{ borderBottom: "1px solid #f0f4f8", transition: "background 0.15s" }}
                          onMouseEnter={e => e.currentTarget.style.background = "#f8f9fe"}
                          onMouseLeave={e => e.currentTarget.style.background = "white"}
                        >
                          <td style={{ padding: "10px 12px", fontWeight: "600", color: "#2d3748" }}>Krishna Kant</td>
                          <td style={{ padding: "10px 12px" }}>
                            <span className="badge" style={{ background: "#eef0ff", color: "#1a3a8f", fontWeight: "600", fontSize: "12px" }}>
                              KKK0000220
                            </span>
                          </td>
                          <td style={{ padding: "10px 12px", color: "#4a5568", fontFamily: "monospace", fontSize: "12px" }}>WTUP0329122758015439</td>
                          <td style={{ padding: "10px 12px" }}>
                            <span style={{ color: "#e53e3e", fontWeight: "600" }}>₹ 0.00</span>
                          </td>
                          <td style={{ padding: "10px 12px" }}>
                            <span style={{ color: "#38a169", fontWeight: "600" }}>₹ 20.00</span>
                          </td>
                          <td style={{ padding: "10px 12px" }}>
                            <span style={{ color: "#1a3a8f", fontWeight: "700" }}>₹ 299778.77</span>
                          </td>
                          <td style={{ padding: "10px 12px" }}>
                            <span className="badge rounded-pill" style={{ background: "#f0fff4", color: "#38a169", border: "1px solid #c6f6d5", fontSize: "11px", fontWeight: "600" }}>
                              PG UPLOAD-CREDIT
                            </span>
                          </td>
                          <td style={{ padding: "10px 12px", color: "#6c757d", whiteSpace: "nowrap", fontSize: "12px" }}>3/29/2025 12:28 PM</td>
                          <td style={{ padding: "10px 12px", color: "#6c757d", maxWidth: "180px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                            title="AMOUNT ADDED THROUGH PG - WALLET-TOP-UP">
                            AMOUNT ADDED THROUGH PG - WALLET-TOP-UP
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div className="table-pagination">
                  <div className="dataTables_info" style={{ fontSize: "12px", color: "#8a9ab5" }} role="status">
                    Showing 11 to 18 of 18 entries
                  </div>
                  <div className="dataTables_paginate paging_simple_numbers">
                    <ul className="pagination mb-0" style={{ gap: "4px" }}>
                      <li className="paginate_button page-item previous">
                        <a href="javascript:void(0)" className="page-link"
                          style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", color: "#1a3a8f", fontSize: "13px" }}>
                          <i className="fa-solid fa-angle-left"></i>
                        </a>
                      </li>
                      <li className="paginate_button page-item">
                        <a href="javascript:void(0)" className="page-link"
                          style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", fontSize: "13px" }}>1</a>
                      </li>
                      <li className="paginate_button page-item active">
                        <a href="javascript:void(0)" className="page-link"
                          style={{ borderRadius: "8px", fontSize: "13px" }}>2</a>
                      </li>
                      <li className="paginate_button page-item next disabled">
                        <a href="javascript:void(0)" className="page-link"
                          style={{ borderRadius: "8px", border: "1.5px solid #dde3ef", color: "#1a3a8f", fontSize: "13px" }}>
                          <i className="fa-solid fa-angle-right"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </section>
    </>
  )
}

export default SupplierLedger